import styles from './Button.module.scss';
import { ButtonProps, TextSize } from "../../../types/button.types";


interface TextButtonProps extends ButtonProps {
    text?: string,
    textSize?: TextSize,
    style?: string,
    textStyle?: string,
}

const Button = (props: TextButtonProps) => {
    return (
        <div className={[styles['text-button'], styles[props.styleType], props.style].join(" ")} onClick={props.callback}>
            {
                props.text && props.textSize
                    ?
                    <p className={styles[props.textSize ?? '']}>{props.text?.toUpperCase()}</p>
                    :
                    <span className={"material-symbols-outlined " + styles['button-icon']}>play_arrow</span>
            }
        </div>
    );
}

export default Button;
